import { render, staticRenderFns } from "./ContentEditor.vue?vue&type=template&id=59051ab0&scoped=true&"
import script from "./ContentEditor.vue?vue&type=script&lang=js&"
export * from "./ContentEditor.vue?vue&type=script&lang=js&"
import style0 from "./ContentEditor.vue?vue&type=style&index=0&id=59051ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59051ab0",
  null
  
)

export default component.exports